import React from "react";
import { twMerge } from "tailwind-merge";

export default function Input(props) {
  return (
    <input
      type="text"
      {...props}
      className={twMerge(
        "mt-1 rounded w-full  border-b border-slate-300/50  bg-transparent  focus:ring focus:ring-violet-500 placeholder:text-slate-300/70",
        props?.className
      )}
    />
  );
}
